import { isMOS3AppServiceAvailable } from "./isMOS3AppServiceAvailable";
import type { MailboxInfo } from "owa-client-types";
import { getApplicationSettings } from "owa-application-settings";

export function isMOS3AppServiceAppsInMailAvailable(mailboxInfo?: MailboxInfo): boolean {
    const isMOS3Available = isMOS3AppServiceAvailable(mailboxInfo);
    
    if (!isMOS3Available) {
        return false;
    }
    
    const mos3AppServiceAppsInMailAvailable = getApplicationSettings("MOS", mailboxInfo).mos3AppServiceAppsInMail;
    
    return mos3AppServiceAppsInMailAvailable;
}
